module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4b7bbfa676e03d5a7b152ff50d6cad08.png";